import { navigate } from 'gatsby';
import propType from 'prop-types';
import React, { useEffect, useState } from 'react';
import Search from '../../assets/svgs/search.svg';

export default function PostSearchBar({
  defaultValue,
  from,
  category,
  ...props
}) {
  const [query, setQuery] = useState('');
  const handleChangeSearchQuery = (e) => {
    setQuery(e.target.value);
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter' && query) {
      const queryString = new URLSearchParams({
        keywords: query,
        from,
        category
      });

      // remove query without value
      queryString.forEach((value, key) => {
        if (value === null || value === '') queryString.delete(key);
      });

      navigate(`/search?${queryString.toString()}`);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    setQuery(defaultValue);
  }, [setQuery, defaultValue]);

  return (
    <form className="post-search" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Search topics and key words"
        name="search"
        value={query}
        onChange={handleChangeSearchQuery}
        onKeyDown={handleSearch}
        className="post-search__input"
        {...props}
      />
      <Search className="post-search__icon" />
    </form>
  );
}

PostSearchBar.defaultProps = {
  defaultValue: '',
  from: '/blog',
  category: ''
};

PostSearchBar.propTypes = {
  defaultValue: propType.string,
  from: propType.string,
  category: propType.string
};
